import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function TestSection({ data,bgColor }) {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const activeData = data.tabs[activeTab].content;

  return (
    <div className="test-section py-5" style={{ "--section-bg": bgColor || "#080F1E" }} >
      <div className="custom-container text-center">
        {/* TITLE */}
        <h2 className="main-title FS40FW600">
          {data?.title} <span className="text-success FS40FW600">{data?.highlight}</span>{" "}
          <br />
          {data?.subtitle}
        </h2>

        {/* TABS */}
        <div className="tab-wrapper justify-content-center mt-4">
          {data.tabs.map((tab, i) => (
            <button
              key={i}
              className={`tab-btn ${i === activeTab ? "active" : ""}`}
              onClick={() => setActiveTab(i)}
            >
              <span className="me-2">{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </div>

        {/* CONTENT */}
        {data.description && 
          <p className="FS18FW400 plus-sans mt-3">
            {data?.description}
          </p>
        }

        <div className="row g-4 justify-content-center mt-4">

        {/* LEFT */}
        <div className="col-md-5 d-flex">
          <div className="info-card w-100 plus-sans">
            <img src="/images/web-new-images/testIcon.svg" alt="What It Tests" className="mb-2" />
            <h5 className="FS24FW500 fw-700">{activeData.leftTitle}</h5>
            <ul className="feature-list FS17FW500 fw-500">
              {activeData.leftPoints.map((p, i) => (
                <li key={i}>{p}</li>
              ))}
            </ul>
          </div>
        </div>

        {/* RIGHT */}
        <div className="col-md-5 d-flex">
          <div className="info-card w-100 plus-sans">
            <img src="/images/web-new-images/yourApprochIcon.svg" alt="Our Approach" className="mb-2" />
            <h5 className="FS24FW500 fw-700">{activeData.rightTitle}</h5>
            <ul className="feature-list FS17FW500 fw-500">
              {activeData.rightPoints.map((p, i) => (
                <li key={i}>{p}</li>
              ))}
            </ul>
          </div>
        </div>

      </div>
              <div>
                <p className="text-center FS18FW400 plus-sans mt-3">
                {data.bottomDescription && (data.bottomDescription)}
                </p>
              </div>
        {/* CTA */}
        <button className="plus-sans FS17FW500 primary-btn mt-4" onClick={() => navigate(data.ctaLink || '/auth/register')}>{data.cta}  <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" /></button>
      </div>
    </div>
  );
}
